// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: "http://localhost:58980/",
  scopeUri: ["api://859f156b-3923-44f6-b5a0-91db806a2f59/StiftelseAnsokan"],
  tenantId: "0926b528-7a8c-4cc6-acdf-66f2149b07bb",
  uiClienId: "e86df25d-d951-4738-9dbd-3859540ff93a",
  redirectUrl: "http://localhost:4200"
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
